import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Absolute extends OBase {
  update () {
    let valTree = this.getFloatOrVectorInput('Value');
    let pOutput = this.getGenericObjectOutput('Result');

    var outTree = new Geometry.DataTree();

    for (let i = 0; i < valTree.branches.length; i++) {
      for (let j = 0; j < valTree.branches[i].length; j++) {
        let val = valTree.branches[i][j];
        let ret;
        if (val instanceof THREE.Vector3) {
          ret = new THREE.Vector3(Math.abs(val.x), Math.abs(val.y), Math.abs(val.z));
        } else {
          ret = Math.abs(val);
        }
        outTree.add(ret, valTree.paths[i]);
      }
    }

    pOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Absolute.js